import { render, staticRenderFns } from "./UpdateSerDevice.vue?vue&type=template&id=2524b890&"
import script from "./UpdateSerDevice.vue?vue&type=script&lang=js&"
export * from "./UpdateSerDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports